// extracted by mini-css-extract-plugin
module.exports = {"searchResultData":"hxbkY","noTabRender":"W0e8v"};